import React, { useCallback, useEffect, useState } from 'react'
import { Form, Input, Row, Col, Button, Tooltip } from 'antd'
import {
    GetParentCategoryss,
    SaveClientCategory,
} from '../../../Services/CreateCatogry'
import { connect, useDispatch } from 'react-redux'
import {
    type saveClientCategory,
    type createCategoryParentStateInterface,
    type createcategoryProps,
} from '../../../Types/CreateCategory'
import { CheckclientcatergoryNameExist } from '../../../Services/Helpdesk/CreteTask'
import { SuccessMessage } from '../../../Utils/Notification'
import commontStyles from '../../../Utils/Common.less'
import {
    commonTableParams,
    setCommonTableParamsData,
} from '../../../Utils/CommontTable'
import { type TableParamsInterface } from '../../../Types/CommonType'
import { GetDYNAMICClientDetails } from '../../../Services/Common'
const CreateCategory = (props: createcategoryProps): React.ReactElement => {
    const {
        changeCreateEditModalStatus,
        clinetDynamicategory,
        clientParentCategoryDropDown,
        resetdata,
        setResetData,
    } = props
    const [tableParams] = useState<TableParamsInterface>(commonTableParams)
    const [form] = Form.useForm()
    const dispatch = useDispatch()
    const [buttonloading, setButtonLoading] = useState(false)

    useEffect(() => {
        if (resetdata === 'true') {
            form.resetFields()
        }
        setResetData('false')
    }, [resetdata])

    useEffect(() => {
        form.setFieldValue('clientDynCategoryId', '0')
    }, [])
    useEffect(() => {
        if (clinetDynamicategory !== '0') {
            const clientParent = clientParentCategoryDropDown?.find(
                (item) =>
                    item.clientDynCategoryId === Number(clinetDynamicategory)
            )
            form.setFieldValue('clientDynCategoryId', clinetDynamicategory)
            form.setFieldValue(
                'clientDynCategoryName',
                clientParent?.clientDynCategoryName
            )
            form.setFieldValue(
                'clientNoStartFrom',
                clientParent?.clientNoStartFrom
            )
        } else {
            form.setFieldValue('clientDynCategoryId', 0)
            form.setFieldValue('clientDynCategoryName', '')
            form.setFieldValue('clientNoStartFrom', 0)
        }
    }, [clinetDynamicategory])

    const handleOk = (): void => {
        const formValues = form.getFieldsValue()
        void SaveClientCategoryData(formValues)
    }

    const getTableData = useCallback(() => {
        const { pageNo, sortOrderList, searchCriteriaList } =
            setCommonTableParamsData(tableParams)
        GetParentCategoryss(dispatch, 0, {
            pageNo,
            pageSize: 1000,
            searchCriteriaList,
            sortOrderList,
        })
    }, [
        tableParams?.sorter,
        tableParams.pagination?.current,
        tableParams?.filter,
    ])
    const SaveClientCategoryData = async (
        data: saveClientCategory
    ): Promise<void> => {
        try {
            const categoryExists = await onNameChange()
            setButtonLoading(true)
            if (categoryExists === 'false') {
                if (clinetDynamicategory === '0') {
                    const result = await SaveClientCategory(dispatch, data)

                    if (result !== null && result !== undefined) {
                        // Save related child data
                        await SaveChildData(
                            result.data.clientDynCategoryId,
                            'Registered Clients',
                            0
                        )
                        await SaveChildData(
                            result.data.clientDynCategoryId,
                            'OnBoarding Clients',
                            0
                        )
                        await SaveChildData(
                            result.data.clientDynCategoryId,
                            'Prospect Clients',
                            0
                        )

                        SuccessMessage('Client Category Save Successfully')
                    }
                } else {
                    const datass = {
                        clientDynCategoryId: data.clientDynCategoryId,
                        clientDynCategoryName: data.clientDynCategoryName,
                        clientDynCategoryParentId: 0,
                        clientNoStartFrom: data.clientNoStartFrom,
                    }
                    await SaveClientCategory(dispatch, datass)

                    SuccessMessage('Client Category Update Successfully')

                    changeCreateEditModalStatus()
                }
                getTableData()
                GetDYNAMICClientDetails(dispatch)
                form.resetFields()
                setButtonLoading(false)
            }
        } catch (error) {
            console.error('Error saving client category data:', error)
        }
    }
    const SaveChildData = async (
        clientDynCategoryIdVar: number,
        childDataName: string,
        clientDynCategoryIds: number
    ): Promise<void> => {
        const dataToSend = {
            clientDynCategoryId: clientDynCategoryIds,
            clientDynCategoryParentId: clientDynCategoryIdVar,
            clientDynCategoryName: childDataName,
            clientNoStartFrom: '0',
        }

        try {
            const result = await SaveClientCategory(dispatch, dataToSend)

            if (result !== null && result !== undefined) {
                changeCreateEditModalStatus()
            }
        } catch (error) {
            console.error('Error saving child data:', error)
        }
    }

    const onNameChange = async (): Promise<string> => {
        const categoryName = form.getFieldValue('clientDynCategoryName') ?? ''

        try {
            const exists = await CheckclientcatergoryNameExist(
                dispatch,
                '0',
                categoryName
            )
            return exists
        } catch {
            return 'Error'
        }
    }

    const customizeRequiredMark = (
        label: React.ReactNode,
        { required }: { required: boolean }
    ): React.ReactElement => (
        <>
            {label}
            &nbsp;
            {required && <span className={commontStyles.requireIcon}>*</span>}
        </>
    )

    return (
        <>
            <Form
                layout="vertical"
                onFinish={handleOk}
                form={form}
                requiredMark={customizeRequiredMark}
            >
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item name="clientDynCategoryId" hidden={true}>
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item name="clientNoStartFrom" hidden={true}>
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Category Name"
                            name="clientDynCategoryName"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input the category name!',
                                },
                            ]}
                        >
                            <Input placeholder="Enter category name" />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col offset={20} span={4}>
                        <Tooltip title="Save">
                            <Button
                                htmlType="submit"
                                type="primary"
                                loading={buttonloading}
                            >
                                Save
                            </Button>
                        </Tooltip>
                    </Col>
                </Row>
            </Form>
        </>
    )
}

const mapStateToProps = (state: any): createCategoryParentStateInterface => {
    return {
        clientParentCategoryDropDown:
            state.initial.clientParentCategoryDropDown,
        clientParentCategoryDropDownCount:
            state.initial.clientParentCategoryDropDownCount,
        isLoading: state.common.isLoading,
    }
}

export default connect(mapStateToProps)(CreateCategory)
